/* eslint-disable indent */
/* eslint-disable jsx-quotes */
import React from 'react';

import ItemOptionManageQuestion from './components/ItemOptionManageQuestion';
import Loader from '../loader-component/loader';

import './manage-question.css';

export default class ManageQuestionPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            onCancel,
            title,
            handleInputText,
            handleItemsOptionQuestion,
            options,
            checkedOption,
            titleOption,
            handleUpdateQuestion,
            handleRemoveItemsOptionQuestion,
            handleSelectCorrectOptionQuestion,
            checkedEnableQuestion,
            handleEnableItemsOptionQuestion,
            hasOption,
            optionsValid,
            optionsValidToAddOptions,
            loading,
            editMode,
            editTitleOption,
            checkedCorrectOption,
            enableEditMode,
            disableEditMode,
            saveOptionEditMode,
        } = this.props;

        return (
            <section className="container-manage-question">
                <p className="title-modal">Gerenciar questão</p>
                <section className="form-add-question">
                    <span className="form-add-question-content">
                        <span className="checked">
                            <input
                                id="checkedEnableQuestion"
                                onChange={({ target }) =>
                                    handleInputText({
                                        name: 'checkedEnableQuestion',
                                        value: target.checked,
                                    })
                                }
                                type="checkbox"
                                name="checkedEnableQuestion"
                                checked={checkedEnableQuestion}
                            />
                            <label htmlFor="checkedEnableQuestion">
                                Ativar/Desativar questão
                            </label>
                        </span>
                        <span className="field">
                            <label htmlFor="title">Título</label>
                            <textarea
                                id="title"
                                onChange={({ target }) =>
                                    handleInputText(target)
                                }
                                type="text"
                                name="title"
                                value={title}
                            />
                        </span>
                        {options && options.length > 0 && (
                            <React.Fragment>
                                {options.find(item => !item.removed) && (
                                    <p className="label-title-option">Opções</p>
                                )}
                                {options.map((item, index) =>
                                    !item.removed ? (
                                        <ItemOptionManageQuestion
                                            key={index}
                                            option={item}
                                            handleSelectCorrectOptionQuestion={
                                                handleSelectCorrectOptionQuestion
                                            }
                                            handleRemoveItemsOptionQuestion={
                                                handleRemoveItemsOptionQuestion
                                            }
                                            handleEnableItemsOptionQuestion={
                                                handleEnableItemsOptionQuestion
                                            }
                                            enableEditMode={enableEditMode}
                                            editMode={editMode}
                                        />
                                    ) : null,
                                )}
                            </React.Fragment>
                        )}
                        <span className="add-item">
                            {!editMode ? (
                                <React.Fragment>
                                    <span className="field">
                                        <label htmlFor="titleOption">
                                            Título da opção
                                        </label>
                                        <textarea
                                            id="titleOption"
                                            onChange={({ target }) =>
                                                handleInputText(target)
                                            }
                                            type="text"
                                            name="titleOption"
                                            value={titleOption}
                                        />
                                        {hasOption && (
                                            <p className="error-text">
                                                Já existe essa opção
                                            </p>
                                        )}
                                    </span>
                                    <span className="checked">
                                        <label htmlFor="checkedOption">
                                            Opção correta?
                                        </label>
                                        <input
                                            id="checkedOption"
                                            onChange={({ target }) =>
                                                handleInputText({
                                                    name: 'checkedOption',
                                                    value: target.checked,
                                                })
                                            }
                                            type="checkbox"
                                            name="checkedOption"
                                            checked={checkedOption}
                                        />
                                    </span>
                                    <button
                                        onClick={() =>
                                            handleItemsOptionQuestion({
                                                title: titleOption,
                                                correct: checkedOption,
                                                enabled: true,
                                            })
                                        }
                                        className={
                                            titleOption === '' ||
                                            !optionsValidToAddOptions ||
                                            hasOption
                                                ? 'disabled-button'
                                                : ''
                                        }
                                        disabled={
                                            titleOption === '' ||
                                            !optionsValidToAddOptions ||
                                            hasOption
                                                ? true
                                                : false
                                        }
                                        type="button"
                                    >
                                        Adicionar Opção
                                    </button>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <p className="label-title-option">
                                        Atualizar opção
                                    </p>
                                    <span className="field">
                                        <label htmlFor="editTitleOption">
                                            Título da opção
                                        </label>
                                        <textarea
                                            id="editTitleOption"
                                            onChange={({ target }) =>
                                                handleInputText(target)
                                            }
                                            type="text"
                                            name="editTitleOption"
                                            value={editTitleOption}
                                        />
                                        {hasOption && (
                                            <p className="error-text">
                                                Já existe essa opção
                                            </p>
                                        )}
                                    </span>
                                    <span className="checked">
                                        <label htmlFor="checkedCorrectOption">
                                            Opção correta?
                                        </label>
                                        <input
                                            id="checkedCorrectOption"
                                            onChange={({ target }) =>
                                                handleInputText({
                                                    name:
                                                        'checkedCorrectOption',
                                                    value: target.checked,
                                                })
                                            }
                                            type="checkbox"
                                            name="checkedCorrectOption"
                                            checked={checkedCorrectOption}
                                        />
                                    </span>
                                    <button
                                        onClick={() =>
                                            saveOptionEditMode({
                                                title: editTitleOption,
                                                correct: checkedCorrectOption,
                                            })
                                        }
                                        className={
                                            editTitleOption === '' ||
                                            !optionsValidToAddOptions ||
                                            hasOption
                                                ? 'disabled-button'
                                                : ''
                                        }
                                        disabled={
                                            editTitleOption === '' ||
                                            !optionsValidToAddOptions ||
                                            hasOption
                                                ? true
                                                : false
                                        }
                                        type="button"
                                    >
                                        Atualizar item
                                    </button>
                                </React.Fragment>
                            )}
                            {editMode && (
                                <button
                                    className="cancel-btn"
                                    onClick={disableEditMode}
                                    type="button"
                                >
                                    Cancelar
                                </button>
                            )}
                        </span>
                    </span>
                </section>
                <span className="line-buttons">
                    <button
                        className="back-btn"
                        type="button"
                        onClick={onCancel}
                    >
                        Voltar
                    </button>
                    <button
                        onClick={() => {
                            handleUpdateQuestion({
                                question: title,
                                options: options,
                                enabled: checkedEnableQuestion,
                            });
                        }}
                        className={
                            title === '' || !optionsValid
                                ? 'update-btn disabled-button'
                                : 'update-btn'
                        }
                        disabled={title === '' || !optionsValid }
                        type="button"
                    >
                        Atualizar questões
                    </button>
                </span>
                {loading > 0 && (
                    <Loader
                        show={loading > 0 ? true : false}
                        message={'Carregando, por favor aguarde...'}
                    />
                )}
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/manage-question/manage-question-presentation.js